import axiosInstance from '../../api/axiosInstance'

/**
 * Tiny shared module between the top-bar trigger (Sidebar) and the panel (ChatWidget).
 *
 * Deliberately free of any heavy import so the top bar can use it without pulling
 * the markdown renderer or the panel itself into the main bundle.
 *
 * The panel cannot live inside the header: `.pc-header` sets `backdrop-filter`,
 * which makes it a containing block for `position: fixed` children, so a panel
 * rendered there would be clipped by the header instead of floating over the page.
 * The trigger therefore dispatches an event that the panel (mounted in Admin.jsx)
 * listens for.
 */

export const ASSISTANT_TOGGLE_EVENT = 'assistant:toggle'

// Single in-flight/resolved request shared by every caller, so mounting the
// trigger and the panel costs one HTTP call, not two.
let statusPromise = null

export function getAssistantEnabled() {
    if (!statusPromise) {
        statusPromise = axiosInstance
            .get('assistant/status')
            .then((res) => Boolean(res.data?.enabled))
            .catch(() => false)
    }
    return statusPromise
}

/** Let the settings page force a re-check after the admin flips the switch. */
export function resetAssistantStatus() {
    statusPromise = null
}

// The panel is lazy-loaded, so a click can land before its chunk has evaluated.
// The intent is parked here and the panel picks it up when it mounts.
let pendingToggle = false

export function toggleAssistantPanel() {
    pendingToggle = true
    window.dispatchEvent(new CustomEvent(ASSISTANT_TOGGLE_EVENT))
}

/** Consumed once by the panel on mount to honour a click that arrived too early. */
export function consumePendingToggle() {
    const had = pendingToggle
    pendingToggle = false
    return had
}
